import on from "./on.svg";
import off from "./off.svg";
export default { on, off };
